module.exports = __webpack_public_path__ + "static/media/whatIsAMatNew.2a69d0d5.png";